'use strict';

import {
    Buildings,
    cardsData,
    isDesktop,
    isMobile,
    projectMode,
    settingsData, TRoot, UIRoot
} from '../../../settings';
import { createHtmlElement, userPrevent } from '../../../functions';
import {UnitCardClass} from "../../cards/unitCards/UnitCardClass";
import gsap from 'gsap';
import {enableOrbitControls} from "../../controls/orbitControls";
import {BaseElement} from "../../interfaces/BaseElement";
import {changeLangToCurrent} from "../langSwitcher/langSwitcher";

export class FloorSlider {
    constructor (container) {
        this.defaultContainer = this.#calculateParent();
        this.container = container || this.defaultContainer;
        this.rightNavBar = document.querySelector('.right-nav-bar');
        this.floors = [];
        this.isScrolling = null;
        this.slider = null;
        this.leader = null;
        this.maxFloorBtn = null;
        this.minFloorBtn = null;
        this.maxSeparator = null;
        this.minSeparator = null;
        this.blockFloorSLider = false;
        this.fsTop = 0;
        this.leaderHeight = 0;
        this.floorBtnHeight = 0;
        this.floorBtnHalfHeight = 0;
        this.staticBtnHeight = 0;
        this.fsMargin = 50;
        this.plugHeight = 0;
        this.scrollHandler = null;
        this.clickHandler = null;
        this.separatorHandler = null;
        this.visibleBtnsCount = isMobile ? 4 : 5;
    }

    async create() {
        const activeBuilding = Buildings.getActiveBuilding();
        this.floors = activeBuilding.getFloorNumbersForFloorSlider();

        this.slider = createHtmlElement(
          this.container,
          '',
          'div',
          ['fs__main__container', isMobile ? 'background-backdrop-filter' : null]
        );
        this.maxFloorBtn = createHtmlElement(
          this.slider,
          '',
          'button',
          ['fs__static__floor', 'fs__max__floor']);

        if (!isMobile) {
            this.maxSeparator = createHtmlElement(
                this.slider,
                '',
                'div',
                ['leader__separator', 'max__separator', 'icon-more']
            );
        }
        this.leader = new BaseElement('ul')
          .addClass('fs__leader')
          .appendTo(this.slider)
          .DOMElement;

        this.floors.forEach(floor => {
            const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(floor));
            const shortLabel = settingsData.groundFloor.shortLabel;
            const floorElement = new BaseElement('li')
              .addClass('fs__floor__number', isGroundFloor ? 'language-string' : null)
              .innerHtml(isGroundFloor ? changeLangToCurrent(shortLabel) : floor)
              .addAttribute('data-floor', floor)
              .appendTo(this.leader);
            if (isGroundFloor)
                floorElement.addAttribute('data-dictionary', shortLabel);
        });

        const max = Math.max(...this.floors);
        const min = Math.min(...this.floors);
        this.maxFloorBtn.textContent = max;

        this.fsTop = this.slider.getBoundingClientRect().top;

        this.calculateHeight();

        if(!isMobile) {
            this.minSeparator = new BaseElement()
                .addClass('leader__separator', 'min__separator', 'icon-more')
                .appendTo(this.slider);
        }

        const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(min));
        const shortLabel = settingsData.groundFloor.shortLabel;
        this.minFloorBtn = new BaseElement('button')
          .addClass('fs__static__floor','fs__min__floor', isGroundFloor ? 'language-string' : null)
          .innerHtml(isGroundFloor ? changeLangToCurrent(shortLabel) : min)
          .appendTo(this.slider);
        if (isGroundFloor)
            this.minFloorBtn.addAttribute('data-dictionary', shortLabel);

        const plug = createHtmlElement('','','li',['fs__plug']);
        this.leader.insertAdjacentElement('afterbegin',plug);
        this.leader.appendChild(plug.cloneNode());

        await this.click(this.getFloorBtn(settingsData.currentFloor));

        this.scrollHandler = this.scroll.bind(this);
        this.clickHandler = this.click.bind(this);
        this.separatorHandler = this.jump.bind(this);

        this.leader.addEventListener('scroll', this.scrollHandler);
        this.leader.addEventListener('click',this.clickHandler);

        if(!isMobile) {
            this.maxSeparator.addEventListener('click', this.separatorHandler);
            this.minSeparator.event('click', this.separatorHandler);
        }

        this.maxFloorBtn.addEventListener('click', () => this.click(this.getFloorBtn(this.floors[0])));
        this.minFloorBtn.event('click', () => this.click(this.getFloorBtn(this.floors[this.floors.length - 1])));

        if (isMobile)
            this.#mobileMode();
    }

    calculateHeight() {
        if (!this.slider)
            return;

        let usePreset;
        let totalHeight;
        let presetTotalHeight;
        let separator;

        const presetWeb = {
            bottomNavBar: isDesktop
              ? this.getElementHeight('aside__container')
              : this.getElementHeight('bottom__nav-bar')
        };

        if (isMobile) {
            if (settingsData.isLandscape){
                // this.rightNavBar.classList.add('fs-slider-open');
                this.fsTop = 0;
                this.leaderHeight = 100;
            } else {
                this.fsTop = this.slider.getBoundingClientRect().top - this.fsMargin / 2;
                this.leaderHeight = 160;
            }
            this.staticBtnHeight = this.leaderHeight * 0.4;
            this.floorBtnHeight = this.leaderHeight * 0.4;
            this.floorBtnHalfHeight = this.leaderHeight * 0.4 / 2;
        } else {
            usePreset = presetWeb;
            presetTotalHeight = Math.max(...Object.values(usePreset));
            separator = (isMobile)?0:this.maxSeparator.getBoundingClientRect().height * 2;

            if (isDesktop){
                this.slider.classList.add('floor-slider__desktop');
                presetTotalHeight += document.querySelector('.aside__logo').getBoundingClientRect().height ;
                this.fsTop = 0;
            }

            totalHeight = Math.ceil(window.innerHeight - this.fsTop - presetTotalHeight - this.fsMargin - separator);

            this.staticBtnHeight = totalHeight / this.visibleBtnsCount + 2;
            this.floorBtnHeight = (totalHeight - this.staticBtnHeight * 2) / (this.visibleBtnsCount);
            this.floorBtnHalfHeight = Math.ceil(this.floorBtnHeight / 2);
            this.leaderHeight = totalHeight - this.staticBtnHeight * 2;
        }

        this.plugHeight =  this.leaderHeight / 2 - this.floorBtnHalfHeight;

        document.documentElement.style.setProperty('--fsBtnHeight', `${this.floorBtnHeight}px`);
        document.documentElement.style.setProperty('--fsBtnHeightHalf', `${this.floorBtnHalfHeight}px`);
        document.documentElement.style.setProperty('--fsPlugHeight', `${this.plugHeight}px`);
        document.documentElement.style.setProperty('--fsLeaderHeight', `${this.leaderHeight}px`);
        document.documentElement.style.setProperty('--fsMargin', `${this.fsMargin / 2}px`);
        document.documentElement.style.setProperty('--fsStaticBtnHeight', `${this.staticBtnHeight}px`);
    }

    resize(){
        if (!this.slider || cardsData.cardMode.isAmenities)
            return;

        this.calculateHeight();
        const floorBtn = this.getFloorBtn(settingsData.currentFloor);
        const scrollDiff = this.leader.scrollTop + this.plugHeight - floorBtn?.offsetTop;

        this.setActiveFloorNumber();
        this.setActiveFloorNumber(floorBtn);

        gsap.to(this.leader,{
            duration: .3,
            scrollTop: this.leader.scrollTop - scrollDiff
        });
    }

    jump(e){
        const separator = e.target;
        let floorTarget;

        if (separator.classList.contains('max__separator')) {
            floorTarget = this.getFloorBtn(settingsData.currentFloor + this.visibleBtnsCount);
            if (!floorTarget)
                floorTarget = this.getFloorBtn(Math.max(...Object.values(this.floors)) - 1);
        } else if (separator.classList.contains('min__separator')){
            floorTarget = this.getFloorBtn(settingsData.currentFloor - this.visibleBtnsCount);
            if (!floorTarget)
                floorTarget = this.getFloorBtn(Math.min(...Object.values(this.floors)));
        }

        this.click(floorTarget);
    }

    getElementHeight(elementClass){
        return document.querySelector(`.${elementClass}`)
          ? window.innerHeight - document.querySelector(`.${elementClass}`).getBoundingClientRect().top
          : 0;
    }

    remove() {
        this.leader.removeEventListener('scroll',this.scrollHandler);
        this.leader.removeEventListener('click',this.clickHandler);
        this.scrollHandler = null;
        this.clickHandler = null;
        this.slider.remove();
        this.floors = [];
        this.isScrolling = null;
        this.slider = null;
        this.leader = null;
        this.blockFloorSLider = false;
        this.rightNavBar && this.rightNavBar.classList.remove('fs-slider-open');
    }

    scroll(){
        if (this.blockFloorSLider)
            return;
        if (this.isScrolling !== null){
            clearTimeout(this.isScrolling);
            this.isScrolling = null;
        }
        if (userPrevent()) return;
        this.rangeBtnToggle();
        enableOrbitControls(false);
        this.isScrolling = setTimeout(()=>{
            if (!this.leader.children) return;
            for (let number of this.leader.children){
                const scrollDiff = this.leader.scrollTop + this.plugHeight - number.offsetTop;
                if (scrollDiff < this.floorBtnHalfHeight ) {
                    const floor = Number(number.getAttribute('data-floor'));
                    this.setActiveFloorNumber();
                    this.setActiveFloorNumber(number);
                    gsap.to(this.leader,{
                        duration: .3,
                        scrollTop: this.leader.scrollTop - scrollDiff
                    });
                    this.isScrolling = null;
                    this.block();
                    this.changeFloor(floor);
                    return;
                }
            }
        },300);
    }

    getFloorBtn(floor){
        return this.leader?.querySelector(`.fs__floor__number[data-floor="${floor}"]`);
    }

    setActiveFloorNumber(element){
        if (!element){
            const getPrevActiveNumber = this.leader.querySelector('.fs__active__floor');
            getPrevActiveNumber && getPrevActiveNumber.classList.remove('fs__active__floor');
            return;
        }

        element.classList.add('fs__active__floor');
    }

    rangeBtnToggle(){
        const fsMinFloorBtn = this.getFloorBtn(this.floors[this.floors.length - 1]);
        const fsMaxFloorBtn = this.getFloorBtn(this.floors[0]);

        const maxBtnDiff = Math.abs(this.leader.scrollTop + this.plugHeight - fsMaxFloorBtn.offsetTop) - this.floorBtnHalfHeight;
        const minBtnDiff = Math.abs(this.leader.scrollTop + this.plugHeight - fsMinFloorBtn.offsetTop) - this.floorBtnHalfHeight;

        if (maxBtnDiff < this.plugHeight){
            this.maxFloorBtn.classList.add('fs__hide__btn');
            if(!isMobile) {
                this.maxSeparator.classList.add('fs__hide__btn');
            }
        } else {
            this.maxFloorBtn.classList.remove('fs__hide__btn');
            if(!isMobile) {
                this.maxSeparator.classList.remove('fs__hide__btn');
            }
        }

        if (minBtnDiff < this.plugHeight){
            this.minFloorBtn.addClass('fs__hide__btn');
            if(!isMobile) {
                this.minSeparator.addClass('fs__hide__btn');
            }
        } else {
            this.minFloorBtn.removeClass('fs__hide__btn');
            if(!isMobile) {
                this.minSeparator.removeClass('fs__hide__btn');
            }
        }
    }

    async click(floorBtn) {
        if (this.blockFloorSLider)
            return;

        const target = (floorBtn instanceof HTMLElement) ? floorBtn : floorBtn.target;
        if (!target.classList.contains('fs__floor__number'))
            return;
        target.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });

        return new Promise(resolve => {
            setTimeout(() => {
                this.rangeBtnToggle();
                resolve(true);
            }, 500);
        });
    }

    async changeFloor(selectedFloor){
        if (selectedFloor < settingsData.currentFloor) {
            projectMode.FloorPlan.down(selectedFloor);

            if (UIRoot.querySelector('.search__container-main') && !UnitCardClass.cards.length)
                return;

            if (isMobile) {
                // await UnitCardClass.closeMobileCard();
                // openSearchHandler();
            } else {
                UnitCardClass.closeMultipleCards();
            }
        } else if (selectedFloor > settingsData.currentFloor) {
            projectMode.FloorPlan.up(selectedFloor);

            if (UIRoot.querySelector('.search__container-main') && !UnitCardClass.cards.length)
                return;

            if (isMobile) {
                // await UnitCardClass.closeMobileCard();
                // openSearchHandler();
            } else {
                UnitCardClass.closeMultipleCards();
            }
        } else if (selectedFloor === settingsData.currentFloor) {
            enableOrbitControls(true);
            this.unblock();
        }
    }

    block(){
        this.blockFloorSLider = true;
        this.slider.style.pointerEvents = 'none';
        this.leader.style.touchAction = 'none';
    }

    unblock(){
        this.blockFloorSLider = false;
        this.slider.style.pointerEvents = '';
        this.leader.style.touchAction = '';
    }

    updateScroll(currentFloor){
        const floorBtn = this.getFloorBtn(currentFloor);
        const scrollDiff = this.leader.scrollTop + this.plugHeight - floorBtn.offsetTop;

        this.setActiveFloorNumber();
        this.setActiveFloorNumber(floorBtn);
        // this.#selectFirstAvailableApartmentOnTheFloor(currentFloor);

        gsap.to(this.leader,{
            duration: .5,
            scrollTop: this.leader.scrollTop - scrollDiff,
            onStart: () => this.block(),
            onComplete: () => {
                this.rangeBtnToggle();
                this.unblock();
            }
        });
    }

    #mobileMode() {
        const allElements = [...this.slider.children];
        allElements.forEach(element => {
            if (!element.classList.contains('fs__leader') && !element.classList.contains('leader__separator')) {
                element.classList.add('hidden');
            }
        })
    }

    #calculateParent() {
        return isMobile
          ? TRoot
          : document.querySelector('.buttons__wrapper');
    }
}
